import { register, findAll, find } from '../../../../Javascript/Utils.js'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
Swiper.use([Navigation, Pagination])

const componentPrefix = 'oHeaderSliderMenu-'
const componentPrefixSubNav = 'oHeaderSubNavigation-'

const SliderMenu = el => {
  initSubNavigation(el)
  initSlider(el)

  // listen for a custom event that the searchBar was opened to reinit the slider (Organism/Header/Searchbar)
  document.addEventListener('headerSearchInteracted', () => {
    const sliderContainer = find('.swiper-container', el)
    if (sliderContainer && sliderContainer.swiper) {
      sliderContainer.swiper.destroy()
    }
    initSlider(el)
  })
}

const initSubNavigation = (el) => {
  // in case Header contains BrandPartnerBar and SliderMenu
  // the Header has a top-margin in desktop-view!
  // the value of this top-margin has to be considered in calculation
  // for SliderMenu-Dropdowns top-positions
  const header = document.querySelector('.oHeader')
  const headerStyle = window.getComputedStyle(header)
  const headerMarginTop = parseInt(headerStyle.marginTop, 10)

  const navItemWithDropdown = findAll(`.${componentPrefix}dropdown`, el)
  const sliderContainer = find('.swiper-container', el)
  let timer = null
  let submenuHolder = null

  navItemWithDropdown.forEach((opener) => {
    // Prevent touch devices from opening the parent page
    // instead of opening the sub navigation
    find('a', opener).addEventListener('click', (e) => {
      e.preventDefault()
    })

    opener.addEventListener('mouseenter', () => {
      const navItemWithDropdownOpened = findAll(`.${componentPrefix}dropdown--open`, el)
      navItemWithDropdownOpened.forEach((item) => {
        item.classList.remove(`${componentPrefix}dropdown--open`)
      })

      if (submenuHolder) {
        if (submenuHolder.classList.contains(`${componentPrefixSubNav}-open`)) {
          clearTimeout(timer)
          submenuHolder.remove()
        }
      }
      const submenu = find('div', opener)

      opener.classList.add(`${componentPrefix}dropdown--open`)
      submenuHolder = submenu.cloneNode(true)
      submenuHolder.classList.add(`${componentPrefixSubNav}-open`)

      sliderContainer.parentElement.insertBefore(submenuHolder, sliderContainer)

      // Calculate drodown position

      submenuHolder.style.left = `${opener.getBoundingClientRect().left}px`
      submenuHolder.style.top = `${opener.getBoundingClientRect().top - headerMarginTop + 20}px`

      submenuHolder.addEventListener('mouseenter', () => {
        clearTimeout(timer)
      })

      submenuHolder.addEventListener('mouseleave', () => {
        submenuHolder.remove()
        const navItemWithDropdownOpened = findAll(`.${componentPrefix}dropdown--open`, el)
        navItemWithDropdownOpened.forEach((item) => {
          item.classList.remove(`${componentPrefix}dropdown--open`)
        })
      })
    })

    opener.addEventListener('mouseleave', () => {
      timer = setTimeout(() => {
        submenuHolder.remove()
        const navItemWithDropdownOpened = findAll(`.${componentPrefix}dropdown--open`, el)
        navItemWithDropdownOpened.forEach((item) => {
          item.classList.remove(`${componentPrefix}dropdown--open`)
        })
      }, 400)
    })
  })
}

const initSlider = (el) => {
  const sliderContainer = find('.swiper-container', el)
  const slides = findAll('.swiper-slide', sliderContainer)
  const prevButton = find(`.${componentPrefix}swiper-button--prev`, sliderContainer)
  const nextButton = find(`.${componentPrefix}swiper-button--next`, sliderContainer)
  const spaceBetween = 30
  let sliderWidth = 0

  slides.forEach((slide) => {
    sliderWidth += slide.offsetWidth + spaceBetween
  })

  const initSlider = (sliderWidth - spaceBetween) > sliderContainer.offsetWidth + 2
  // console.log(initSlider + ': ' + (sliderWidth - spaceBetween) + ' > ' + (sliderContainer.offsetWidth + 2))

  if (initSlider) {
    sliderContainer.classList.add('swiper')
    const SliderMenuSwiper = new Swiper(sliderContainer, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      }
    })

    SliderMenuSwiper.on('slideChange', function () {
      const activeIndex = SliderMenuSwiper.activeIndex
      if (activeIndex !== 0) {
        if (prevButton) { prevButton.style.display = 'flex' }
      } else {
        if (prevButton) { prevButton.style.display = 'none' }
      }
    })

    SliderMenuSwiper.on('reachEnd', function () {
      if (nextButton) {
        nextButton.style.display = 'none'
      }
    })

    SliderMenuSwiper.on('fromEdge', function () {
      const nextButton = find(`.${componentPrefix}swiper-button--next`, el)
      if (nextButton) {
        nextButton.style.display = 'flex'
      }
    })
  } else {
    if (prevButton) {
      prevButton.remove()
    }
    if (nextButton) {
      nextButton.remove()
    }
  }
}

register('SliderMenu', SliderMenu)
